import {css} from 'styled-components'

const blueGradient = css`
    background: ${(props) => props.theme.colors.gradient.top};
`

export default blueGradient
